import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import FavoriteOutlinedIcon from '@mui/icons-material/FavoriteOutlined';
import InfoOutlineRoundedIcon from '@mui/icons-material/InfoOutlineRounded';
import clsx from 'clsx';
import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import DemoImage from '../demo-image/DemoImage';
import SlideButton from '../../../../../../id8/components/frames/slide-button/SlideButton';
import { REACTIONS } from '../../../../../../constants';

import scss from './DemoSlide.module.scss';

function PreviewDemoSlide({ slide, onLike, disabled, onShowSourceImage }) {
  const { t } = useTranslation('id8');

  const [backgroundImage, setBackgroundImage] = useState(null);

  const handleLike = () => {
    if (onLike && !disabled) {
      onLike(slide);
    }
  };

  const handleShowSource = () => {
    if (!disabled) {
      onShowSourceImage(slide);
    }
  };

  const handleImageLoaded = (url) => {
    setBackgroundImage(url);
  };

  return (
    <div className={scss.previewSlide}>
      <img src={backgroundImage} alt='preview' aria-hidden='true' className={scss.previewSlideBackground} />

      <DemoImage
        sessionId={slide.sessionId}
        className={scss.previewSlideImage}
        disabled={disabled}
        onImageLoaded={handleImageLoaded}
      />

      <div className={scss.buttonsGroup}>
        {onShowSourceImage && (
          <SlideButton
            icon={InfoOutlineRoundedIcon}
            onClick={handleShowSource}
            ariaLabel='Show source image'
            tooltip={t('sourceImage')}
            disabled={disabled}
          />
        )}

        {onLike && (
          <SlideButton
            icon={slide.reaction === REACTIONS.LIKE ? FavoriteOutlinedIcon : FavoriteBorderOutlinedIcon}
            onClick={handleLike}
            ariaLabel='Like this picture'
            className={clsx(slide.reaction === REACTIONS.LIKE && scss.favoriteSlide)}
            disabled={disabled}
          />
        )}
      </div>
    </div>
  );
}

export default memo(PreviewDemoSlide);
